import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { TableBaseStyle } from './LayerShortSettingStyle';


const LayerShortSettingHeader: React.FC = () => {
  const { t } = useTranslation();
  const classes = TableBaseStyle();

  return (
    <TableRow>
      <TableCell className={classes.tableHeader} width={200}>{t('LayerShortSettingHeader.項目', '項目')}</TableCell>
      <TableCell className={classes.tableHeader} width={100}>{t('LayerShortSettingHeader.設定値', '設定値')}</TableCell>
    </TableRow>
  )
};

export default LayerShortSettingHeader;